import React from "react"
import { Helmet } from "react-helmet"

const MetaIcons = ({
  favicon,
  appleTouchIcon192,
  appleTouchIcon512
}) => (
    <>
      <Helmet
        link={[
          {
            "rel": "icon",
            "type": "image/png",
            "href": favicon ? favicon : "/favicons/hult-48x48.png"
          },
          {
            "rel": "apple-touch-icon",
            "sizes": "192x192",
            "href": appleTouchIcon192 ? appleTouchIcon192 : "/favicons/apple-touch-icons/hult/hult-192x192.png"
          },
          {
            "rel": "apple-touch-icon",
            "sizes": "512x512",
            "href": appleTouchIcon512 ? appleTouchIcon512 : "/favicons/apple-touch-icons/hult/hult-512x512.png"
          }
        ]}
      />
    </>
  )

export default MetaIcons
